import axios from "axios";

class Logger {
  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  async log(level, message, meta = {}, request = "", paymentDetails = {}) {
    try {
      console.log(message, meta);
      delete meta?.checkoutModel?.client_id;
      delete meta?.checkoutModel?.client_secret;
      await axios.post(this.apiEndpoint, {
        activeFrom: paymentDetails.activeFrom ? paymentDetails.activeFrom.toString() : null,
        activeTo: paymentDetails.activeTo ? paymentDetails.activeTo.toString() : null,
        paymentType: paymentDetails.paymentType ? paymentDetails.paymentType.toString() : null,
        orderNumber: paymentDetails.orderNumber ? paymentDetails.orderNumber.toString() : null,
        transactionId: paymentDetails.transactionId
          ? paymentDetails.transactionId.toString()
          : null,
        paymentId: paymentDetails.paymentId ? paymentDetails.paymentId.toString() : null,
        subscriberName: paymentDetails.subscriberName
          ? paymentDetails.subscriberName.toString()
          : null,
        packageName: paymentDetails.packageName ? paymentDetails.packageName.toString() : null,
        purchasePrice: paymentDetails.purchasePrice
          ? parseFloat(paymentDetails.purchasePrice)
          : null,
        currentProcess: paymentDetails.currentProcess
          ? paymentDetails.currentProcess.toString()
          : null,
        tgUserId: paymentDetails.tgUserId ? paymentDetails.tgUserId.toString() : undefined,
        tgRequest: JSON.stringify(paymentDetails.tgRequest ?? null),
        tgResponse: JSON.stringify(paymentDetails.tgResponse ?? null),
        paymentRequest: JSON.stringify(paymentDetails.paymentRequest ?? null),
        paymentResponse: JSON.stringify(paymentDetails.paymentResponse ?? null),
        accountNo: paymentDetails.accountNo ? paymentDetails.accountNo.toString() : null,
        type: level,
        message,
        request: request,
        response: JSON.stringify(meta),
      });
    } catch (error) {
      console.error("Failed to send log to server:", error.message);
    }
  }
}

const logger = new Logger(process.env.REACT_APP_AMSYS_LOG_URL);
export default logger;
